webpackJsonp([96961042003272],{

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    font-size: 3em;\n    font-weight: 600;\n    text-align: center;\n    margin: 0 0 2rem 0;\n  "], ["\n    font-size: 3em;\n    font-weight: 600;\n    text-align: center;\n    margin: 0 0 2rem 0;\n  "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    margin: 0 auto;\n    max-width: ", ";\n    padding: 3em 1.5em 2em;\n  "], ["\n    margin: 0 auto;\n    max-width: ", ";\n    padding: 3em 1.5em 2em;\n  "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _siteConfig = __webpack_require__(42);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _body = __webpack_require__(151);
	
	var _body2 = _interopRequireDefault(_body);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PageTemplate = function PageTemplate(_ref) {
	  var data = _ref.data;
	  var _data$contentfulPage = data.contentfulPage,
	      title = _data$contentfulPage.title,
	      id = _data$contentfulPage.id,
	      slug = _data$contentfulPage.slug,
	      body = _data$contentfulPage.body,
	      description = _data$contentfulPage.description;
	
	
	  var Title = _styledComponents2.default.h1(_templateObject);
	
	  var Page = _styledComponents2.default.section(_templateObject2, function (props) {
	    return props.theme.sizes.maxWidthCentered;
	  });
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        title + " - " + _siteConfig2.default.siteTitle
	      ),
	      _react2.default.createElement("meta", { name: "description", content: description.description }),
	      _react2.default.createElement("meta", { property: "og:title", content: title + " - " + _siteConfig2.default.siteTitle }),
	      _react2.default.createElement("meta", { property: "og:url", content: _siteConfig2.default.siteUrl + "/" + slug + "/" })
	    ),
	    _react2.default.createElement(
	      Page,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        title
	      ),
	      _react2.default.createElement(_body2.default, {
	        dangerouslySetInnerHTML: { __html: body.childMarkdownRemark.html }
	      })
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = PageTemplate;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-e163c1de075d540469a4.js